import React from 'react';
import { IconButton, SvgIcon } from '@mui/material';
import { ReactComponent as iconCheckedBox } from 'assets/images/icons/table/checkedBox.svg';
import { IconButtonProps } from 'types/icon';

const CampaignCheckBoxChecked: React.FC<IconButtonProps> = ({
    width = '16px',
    height = '16px',
    color = 'white',
    onClick,
}) => {
    return (
        <IconButton onClick={onClick}>
            <SvgIcon
                component={iconCheckedBox}
                inheritViewBox
                style={{ width, height, color }}
            />
        </IconButton>
    );
};

export default CampaignCheckBoxChecked;
